

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _constants = require('./constants');

var _customUtil = require('./customUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function () {
    return [function angularDebug() {

        window.root = _angular.$rootScope;
        window.injector = _angular2['default'].element(document.body).injector();
    }, function resolveLocale() {
        function retrieveLocale() {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    checkoutSessionLocale: lcParam,
                    countryParam: _squid.$util.param('country.x'),
                    localeParam: _squid.$util.param('locale.x') || lcParam,
                    merchantCountry: merchantCountry
                }
            });
        }

        var jsonXclick = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams);
        var lcParam = jsonXclick && jsonXclick.lc;
        var merchantCountry = jsonXclick && jsonXclick.merchant_country;

        if (jsonXclick && jsonXclick.wa_type === _constants.SHOPPINGCART_WA_TYPE && _constants.EN_DEFAULTS[lcParam]) {
            lcParam = _constants.EN_DEFAULTS[lcParam];
        }

        return retrieveLocale();
    }, function logPage() {

        _logger.$logger.info('href', {
            href: window.location.href,
            windowName: _angular.$window.name
        });

        /* let match = document.cookie.toString().match(/ectoken=([^;]+)/);
         if (match && match[1] === $rootScope.token) {
            $logger.info('returning_user_same_token');
        } else if (match && match[1] !== $rootScope.token) {
            $logger.info('returning_user_diff_token');
        } else {
            $logger.info('non_returning_user');
        }
         document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
        */
        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {

            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                _logger.$logger.info('navigation_' + navigationType);
            }
        }
    }, function logPerformance() {
        if (window.enablePerformance) {

            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];

            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        _logger.$logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            _logger.$logger.info('timing', timing);

            if (window.performance.memory) {
                _logger.$logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                _logger.$logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                    if (['link', 'script', 'img', 'css'].indexOf(resource.initiatorType) > -1) {
                        _logger.$logger.info(resource.initiatorType, resource);
                    }
                });
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                _logger.$logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            _logger.$logger.info('no_performance_data');
        }
    }];
});

_logger.$logger;

_squid.$locale;

_squid.$meta;

_squid.$util;

_constants.SHOPPINGCART_WA_TYPE;

_constants.EN_DEFAULTS;

_customUtil.customUtil;


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 0